import { InvoiceStatuses } from '@insurance/types'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const statusList = Object.values(InvoiceStatuses)

export const statusOptions = (
  t: TFunction,
  includeStatuses?: InvoiceStatuses[]
): SelectProps['options'] => {
  const filteredStatusList = includeStatuses
    ? statusList.filter((status) => includeStatuses.includes(status))
    : statusList

  return filteredStatusList.map((value) => ({
    label: t(value),
    value
  }))
}
